import { Model } from '@/models/Model';
import { User } from '@/models/User';

export class ExcelExportLogs extends Model {
  protected $name = 'ExcelExportLogs';

  protected $endpoint = '/hin/excel-export-logs';

  protected $primaryKey = 'id';

  protected $fillable: string[] = [];

  public id!: string;

  public created_at!: string;

  public type!: ExcelExportLogsType;

  public user?: User;

  public get typeLabel(): string {
    const types: Record<ExcelExportLogsType, string> = {
      general_hin_report_statistics: 'Rapportage',
    };

    return types[this.type];
  }
}

export type ExcelExportLogsType = 'general_hin_report_statistics';

export enum ExcelExportLogsFilters {
  USER = 'user',
  USERS = 'users',
  TYPE = 'type',
  TYPES = 'types',
}
export enum ExcelExportLogsIncludes {
  USER = 'user'
}
